export enum ToastTypeEnum {
    SAVED = 'saved',
    SAVING = 'saving',
    ERROR = 'error',
}